import { render } from "./dropdown-list.vue?vue&type=template&id=23e27961"
import script from "./dropdown-list.vue?vue&type=script&lang=js"
export * from "./dropdown-list.vue?vue&type=script&lang=js"

import "./dropdown-list.vue?vue&type=style&index=0&id=23e27961&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__